import { AutoFocusPlugin } from "@lexical/react/LexicalAutoFocusPlugin";
import { ClearEditorPlugin } from "@lexical/react/LexicalClearEditorPlugin";
import { LexicalErrorBoundary } from "@lexical/react/LexicalErrorBoundary";
import { HistoryPlugin } from "@lexical/react/LexicalHistoryPlugin";
import { RichTextPlugin } from "@lexical/react/LexicalRichTextPlugin";
import { SelectionAlwaysOnDisplay } from "@lexical/react/LexicalSelectionAlwaysOnDisplay";
import { useLexicalEditable } from "@lexical/react/useLexicalEditable";
import { CAN_USE_DOM } from "@lexical/utils";
import { useEffect, useState, useCallback } from "react";
import { useSettings } from "../LexicalEditor/context/SettingsContext";
import { useSharedHistoryContext } from "../LexicalEditor/context/SharedHistoryContext";
import ComponentPickerPlugin from "../LexicalEditor/plugins/ComponentPickerPlugin";
import { MaxLengthPlugin } from "../LexicalEditor/plugins/MaxLengthPlugin";
import ContentEditables from "../LexicalEditor/ui/ContentEditable";
// import "./index.css";
import { OnChangePlugin } from "@lexical/react/LexicalOnChangePlugin";
import { $generateHtmlFromNodes } from "@lexical/html";
import InputEditables from "../LexicalEditor/ui/InputEditable";
const skipCollaborationInit =
  // @ts-expect-error
  window.parent != null && window.parent.frames.right === window;

export default function InputEditor({
  editorId,
  editor,
  setFieldState,
  handleEditorChange,
}) {
  const { historyState } = useSharedHistoryContext();
  const {
    settings: {
      isCollab,
      isAutocomplete,
      isMaxLength,
      isCharLimit,
      hasLinkAttributes,
      isCharLimitUtf8,
      isRichText,
      showTreeView,
      showTableOfContents,
      shouldUseLexicalContextMenu,
      shouldPreserveNewLinesInMarkdown,
      tableCellMerge,
      tableCellBackgroundColor,
      tableHorizontalScroll,
      shouldAllowHighlightingWithBrackets,
      selectionAlwaysOnDisplay,
      listStrictIndent,
    },
  } = useSettings();
  const placeholder = "";
  const [floatingAnchorElem, setFloatingAnchorElem] = useState(null);
  const [isSmallWidthViewport, setIsSmallWidthViewport] = useState(false);

  const [activeEditor, setActiveEditor] = useState(editor);
  const [isLinkEditMode, setIsLinkEditMode] = useState(false);

  const onRef = useCallback((_floatingAnchorElem) => {
    if (_floatingAnchorElem !== null) {
      setFloatingAnchorElem(_floatingAnchorElem);
    }
  }, []);

  useEffect(() => {
    const updateViewPortWidth = () => {
      const isNextSmallWidthViewport =
        CAN_USE_DOM && window.matchMedia("(max-width: 1025px)").matches;

      if (isNextSmallWidthViewport !== isSmallWidthViewport) {
        setIsSmallWidthViewport(isNextSmallWidthViewport);
      }
    };
    updateViewPortWidth();
    window.addEventListener("resize", updateViewPortWidth);

    return () => {
      window.removeEventListener("resize", updateViewPortWidth);
    };
  }, [isSmallWidthViewport]);

  const handleEditorOnChange = useCallback((editorState) => {
    if (handleEditorChange) {
      editorState.read(() => {
        let content = $generateHtmlFromNodes(editor);
content = content.replace(/<p class="PlaygroundEditorTheme__paragraph"[^>]*>/g, '');
    content = content.replace(/<\/p>/g, '');
      handleEditorChange(content);
      });
    }
  }, [handleEditorChange, editor]);

  return (
    <>
      <OnChangePlugin onChange={handleEditorOnChange} />

      <div
        className={`editor-containerss ${showTreeView ? "tree-view" : ""} ${
          !isRichText ? "plain-text" : ""
        }`}
      >
        {isMaxLength && <MaxLengthPlugin maxLength={30} />}
        {/* <AutoFocusPlugin /> */}
        {selectionAlwaysOnDisplay && <SelectionAlwaysOnDisplay />}
        <ClearEditorPlugin />
        <ComponentPickerPlugin />
     

        <>
          <RichTextPlugin
            contentEditable={
              <div className="editor-scrollers">
                <div className="editors" ref={onRef}>
                  <InputEditables placeholder={placeholder} />
                </div>
              </div>
            }
            ErrorBoundary={LexicalErrorBoundary}
          />

          <HistoryPlugin externalHistoryState={historyState} />
        </>
      </div>
    </>
  );
}
